import React, { createContext, Component } from 'react';

export const LanguageContext = createContext();

export class LanguageProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: localStorage.getItem('language') || 'en'
        };
    }

    toggleLanguage = () => {
        this.setState(prevState => {
            const newLanguage = prevState.language === 'en' ? 'ar' : 'en';
            localStorage.setItem('language', newLanguage);

            // Update document direction and lang attribute
            document.documentElement.dir = newLanguage === 'ar' ? 'rtl' : 'ltr';
            document.documentElement.lang = newLanguage;

            // Add/remove arabic class from body
            if (newLanguage === 'ar') {
                document.body.classList.add('arabic');
            } else {
                document.body.classList.remove('arabic');
            }

            return { language: newLanguage };
        });
    }

    componentDidMount() {
        // Set initial direction and lang
        const { language } = this.state;
        document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = language;

        // Add arabic class to body if language is Arabic
        if (language === 'ar') {
            document.body.classList.add('arabic');
        } else {
            document.body.classList.remove('arabic');
        }
    }

    render() {
        return (
            <LanguageContext.Provider value={{
                language: this.state.language,
                toggleLanguage: this.toggleLanguage
            }}>
                {this.props.children}
            </LanguageContext.Provider>
        );
    }
}

